import React from 'react'

import './index.scss'

//material-ui

//custom components

//api

//other libraries
import { inject, observer } from 'mobx-react'
import Dropzone from 'react-dropzone'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import CustomButton from '../../../components/basic/CustomButton'
import { api } from '../../../functions/api'

@inject('internal')
@inject('translate')
@observer
export default class Import extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      uploading: false,
      file: null,
      extension: null,
      response: null,
    }
  }
  
  handleDrop = (files) => {
    if (files[0] !== undefined) {
      let fileNameArr = files[0].name.split('.')
      
      let extension = fileNameArr[fileNameArr.length - 1]
      if (extension === 'csv') {
        this.setState({
          file: files[0],
          extension: extension,
        })
      }
    } else {
      this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FORMAT_IS_NOT_VALID, true)
    }
    
  }
  
  handleImport = async () => {
    this.setState({ uploading: true })
    if (this.state.file === null) {
      this.setState({ uploading: false })
      this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.EMPTY_FILE, true)
      return
    }
    let upload_data = await api({
      method: 'post',
      url: 'issue-cards/import',
      formData: true,
      formDataDoc: true,
      authorization: this.props.internal.user.access_token,
      params: {
        file: this.state.file,
      },
    })
    
    if (upload_data.success === true) {
      this.props.internal.setSnackbar(upload_data.data.message, true)
      this.props.onClose(true)
    } else {
      this.setState({
        file: null,
        uploading: false
      }
     )
      this.props.internal.setSnackbar(upload_data.data.message, true, true)
    }
  }
  
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.onClose}
      >
        <DialogTitle className={'title'}>{this.props.title}</DialogTitle>
        <DialogContent className={`import-issue-cards-dialog`}>
          {this.state.uploading ? <CircularProgress className={'circular-progress'}/> : (
            <Dropzone
              onDrop={files => this.handleDrop(files)}
              multiple={false}
              accept={['.csv']}
            >
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()} className={`dropzone ${this.state.file !== null ? 'dropped' : ''}`}>
                  <input {...getInputProps()} />
                  {this.state.file !== null && this.state.file.name ? (
                    <p>{this.state.file.name}</p>
                  ) : (
                    <p>{this.props.translate.i18n.MODULES.CLIENTS.IMPORT_PLACE}</p>
                  )}
                </div>
              )}
            </Dropzone>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose} className={'gray-text'}>
            {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
          </Button>
          
          <CustomButton
            justText
            progressBar={this.state.uploading}
            onClick={this.handleImport}
            mystyle={'btn-white-bg'}
            title={this.props.translate.i18n.GLOBAL.BUTTONS.IMPORT}
          />
        </DialogActions>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/IssueCards/import/index.js